import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms'; import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ExportParams } from '../Model/filterparams';


@Injectable({
  providedIn: 'root'
})
export class EympService {
  [x: string]: any;
  constructor(private _http: HttpClient) { }
  getDashboardCount(startDate, endDate) {
    let params = new HttpParams();
    params = params.append('startDate', startDate);
    params = params.append('endDate', endDate);


    return this._http.get<any>(environment.ApiUrl + 'EYMPNotices/GetEympNoticesDashboardCount', { params: params });
  }
  getEympNoticesDetailsWithStatus(status: string,startDate, endDate, mode: string, filterParams: ExportParams) {

    return this._http.post<any>(environment.ApiUrl + 'EYMPNotices/GetEympNoticeDetailsbyStatus?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate + '&mode=' + mode, filterParams, {});
  }
}
